export const CREATE_MASTER_TASK = "CREATE_MASTER_TASK";
export const FETCH_MASTER_TASKS = "FETCH_MASTER_TASKS";
export const FETCH_MASTER_TASK = "FETCH_MASTER_TASK";
export const EDIT_MASTER_TASK = "EDIT_MASTER_TASK";
export const DELETE_MASTER_TASK = "DELETE_MASTER_TASK";
